import './HeaderBanner.less';
import React, {useState, useEffect} from 'react';
import Request from "../../../../bootstrap/api/Request";
import {PLACE_HOME_HEADER} from "../../../model-constants/banner/places";
import AspectContainer from "../../../../bootstrap/components/aspect-container/AspectContainer";
import Slider from "../../../components/slider/Slider";
import ImageView from "../../../components/image-view/ImageView";
import BannerListParcel from "../../../api/endpoints/banner/BannerListParcel";
import Spinner from "../../../../bootstrap/components/spinner/Spinner";
import ImgView from "../../../components/img-view/ImgView";
import config from "../../../../../../config.json";
import {Link} from 'react-router-dom';
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min';


export default function HeaderBanner({}) {

    const [data, setData] = useState(null);

    useEffect(() => {
        const filters = [{field: 'place', operator: '=', value: PLACE_HOME_HEADER}];
        const filtersConfig = {
            place: {type: 'number'}
        };
        const refNames = ['image'];

        Request.add(new BannerListParcel({filters, filtersConfig, refNames}))
            .then((data) => {
                if (data.items.length === 0) {
                    setData(false);
                    return;
                }

                setData(data);
            })
            .catch((error) => {
                console.log(error);
                setData(false);
            });
    }, []);

    const renderBanner = (banner) => {
        if (banner.linked_url === null || banner.linked_url === '') {
            return (
                <ImageView
                    ratio={3.5}
                    image={refs.images.find(t => t.id === banner.image_id)}
                />
            );
        }

        const url = new URL(banner.linked_url);
        const isSameHost = 'nihao.vn' === url.host;

        if (isSameHost) {
            return (
                <Link
                    aria-label={banner.caption}
                    to={{
                        pathname: url.pathname,
                        search: url.search,
                        hash: url.hash,
                    }}
                >
                    <ImageView
                        ratio={3.5}
                        image={refs.images.find(t => t.id === banner.image_id)}
                    />
                </Link>
            );
        }

        return (
            <a
                href={banner.linked_url}
                aria-label={banner.caption}
                target="_blank'"
            >
                <ImageView
                    ratio={3.5}
                    image={refs.images.find(t => t.id === banner.image_id)}
                />
            </a>
        );
    };

    if (data === null) {
        return <div className="header-banner">
            <AspectContainer ratio={3.5}>
                <Spinner size={2} />
            </AspectContainer>
        </div>;
    }

    if (data === false) {
        return <div className="header-banner">
            <ImgView
                src={config.img_default_banner}
                ratio={3.5}
            />
        </div>;
    }

    const {items, refs} = data;

    if (items.length === 1) {
        return <div className="header-banner">
            {renderBanner(items[0])}
        </div>;
    }

    return <div className="header-banner">
        <Slider
            autorunDelay={3000}
            pageSize={1}
        >
            {
                items.map(item => {
                    return <div key={item.id}>{renderBanner(item)}</div>
                })
            }
        </Slider>
    </div>;
}
